import PropTypes from 'prop-types';
import { ItemsAll } from '../../components/Views/ItemsAll';
import { getSeoData, getValueFromObject } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { getDataForTransformationsQuery } from '../../api/queries';
import { withBugsnagGetServerSideProps } from '../../utils/withBugsnag';
import { extractApolloState } from '../../utils/helpers/extractApolloState';
import { prepareSSRContext } from '../../utils/helpers/ssrContext';

const App = ({ sortingValue, ...rest }) => (
  <ItemsAll {...{ sortingValue, ...rest }} />
);

export const getServerSideProps = withBugsnagGetServerSideProps(async ctx => {
  const { req, query } = ctx;
  const {
    apolloClient,
    apolloOptions,
    currentLang,
    asPath,
    isSSRWebView,
    abTests,
    hasAccessToken
  } = prepareSSRContext(ctx);

  const [dataForTransform, seoData] = await Promise.all([
    apolloClient.query({ query: getDataForTransformationsQuery }),
    getSeoData(apolloClient, asPath, req),
    getStaticData(apolloClient, true)
  ]);

  const sortingValue = query.sorting;

  const sortingName = getValueFromObject(
    dataForTransform.data.sort,
    sortingValue,
    'name'
  );

  return extractApolloState(apolloClient, {
    props: {
      sortingValue: sortingName,
      seoData,
      apolloOptions,
      currentLang,
      isSSRWebView,
      abTests,
      hasAccessToken
    }
  });
}, '/all');

App.propTypes = {
  sortingValue: PropTypes.string,
  currentLang: PropTypes.string,
  seoData: PropTypes.object,
  apolloOptions: PropTypes.object,
  isSSRWebView: PropTypes.bool,
  abTests: PropTypes.object,
  hasAccessToken: PropTypes.bool
};

App.getLayout = (page, pageProps) => (
  <Layout isBackgroundBanner pageProps={pageProps}>
    {page}
  </Layout>
);

export default App;
